export default __webpack_public_path__ + "static/media/image3pro7.b31ad292.jpeg";